import type { CandidateMatchBand } from '@yeshuman/sdk'
import type { Opportunity } from '../hooks/use-opportunities'
import type { CandidateJobsSort } from './list-filters/candidate-jobs-constants'

const MATCH_BANDS = new Set<string>(['strong', 'good', 'mixed', 'limited', 'poor'])

type CandidateSkillProfile = {
  extensions?: {
    candidate?: {
      skills?: string[]
      experiences?: { skills?: string[] }[]
    }
  }
} | null | undefined

export function candidateProfileCanRankJobs(profile: CandidateSkillProfile): boolean {
  const candidate = profile?.extensions?.candidate
  if ((candidate?.skills ?? []).some((name) => Boolean(name?.trim()))) {
    return true
  }
  return (candidate?.experiences ?? []).some((experience) =>
    (experience.skills ?? []).some((name) => Boolean(name?.trim())),
  )
}

export function defaultCandidateJobsSort(rankable: boolean): CandidateJobsSort {
  return rankable ? 'match' : 'updated_desc'
}

export function browseMatchCardFitProps(
  opportunity: Pick<Opportunity, 'match_percent' | 'match_band'>,
  sort: CandidateJobsSort,
): { matchBand: CandidateMatchBand; matchBandCaption: string } | undefined {
  if (sort !== 'match') return undefined
  const band = opportunity.match_band
  if (!band || !MATCH_BANDS.has(band) || opportunity.match_percent == null) {
    return undefined
  }
  return {
    matchBand: band,
    matchBandCaption: `${opportunity.match_percent}%`,
  }
}
